import { SET_ACTIVE_TAB } from '../reducers/active-tabs-reducer'

function setActiveTab(index) {
  return { type: SET_ACTIVE_TAB, value: index }
}

export const setTab = index => dispatch => dispatch(setActiveTab(index))
